import React from 'react'
import logo from '../../assets/navbaricon.png'
import { Link } from 'react-router-dom'

const Privacy = () => {
  return (
    <div className='min-h-screen bg-gray-50'>
      {/* Header Section */}
      <header className=' bg-black text-white py-4'>
        <div className='max-w-7xl mx-auto px-6 flex justify-between items-center'>
          <div className='flex items-center space-x-4'>
            <img src={logo} alt='Logo' className='h-8 w-auto' />
          </div>
          <div className='flex items-center space-x-4'>
            {/* Login Button */}
            <Link
              to='/'
              className='no-underline text-white text-sm font-medium px-4 py-2 rounded-full 
               border border-white/40 hover:bg-white hover:text-black 
               transition-all duration-300'
            >
              Log In
            </Link>

            {/* Signup Button */}
            <Link
              to='/register'
              className='no-underline bg-white text-black text-sm font-semibold px-5 py-2 
               rounded-full shadow-md hover:bg-gray-200 
               transition-all duration-300'
            >
              Sign Up
            </Link>
          </div>
        </div>
      </header>

      {/* Privacy Policy Section */}
      <main className='py-12 px-6'>
        <div className='min-h-screen bg-gray-100 p-8'>
          <div className='max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-6'>
            <h1 className='text-2xl font-bold text-gray-800 mb-4'>
              Privacy Policy
            </h1>

            <div className='space-y-6'>
              {/* 1. Introduction */}
              <section>
                <h2 className='text-xl font-semibold text-gray-700 mb-[10px]'>
                  1. Introduction
                </h2>
                <p className='text-gray-600'>
                  MagBot (“we,” “our,” “us”) is an AI-powered platform that
                  integrates with websites to provide automation and customer
                  support features. We are committed to protecting your privacy
                  and ensuring the security of your information. This Privacy
                  Policy explains how we collect, use, share, and protect your
                  Personal Data when you use MagBot.
                </p>
              </section>

              {/* 2. Controller Information */}
              <section>
                <h2 className='text-xl font-semibold text-gray-700 mb-[10px]'>
                  2. Controller / Contact Information
                </h2>
                <ul className='list-disc pl-6 text-gray-600'>
                  <li>Data Controller: Stepping Edge Technologies Pvt. Ltd.</li>
                  <li>
                    Address: 5, 2nd Floor, Sri Radha Towers, 5, Raja Rajeshwari
                    Nagar, Namachivaya Nagar, Saravanampatti, Coimbatore, Tamil
                    Nadu 641035
                  </li>
                  <li>Email: support@magbot.ai</li>
                </ul>
              </section>

              {/* 3. Definitions */}
              <section>
                <h2 className='text-xl font-semibold text-gray-700 mb-[10px]'>
                  3. Definitions
                </h2>
                <ul className='list-disc pl-6 text-gray-600'>
                  <li>
                    <strong>Personal Data:</strong> Any information that
                    identifies a person (e.g., name, email, IP address).
                  </li>
                  <li>
                    <strong>Usage Data:</strong> Logs, timestamps, browser type,
                    device info.
                  </li>
                  <li>
                    <strong>User:</strong> Any individual using MagBot.
                  </li>
                  <li>
                    <strong>Service:</strong> MagBot chatbot features and
                    automations.
                  </li>
                </ul>
              </section>

              {/* 4. Data We Collect */}
              <section>
                <h2 className='text-xl font-semibold text-gray-700 mb-[10px]'>
                  4. Data We Collect
                </h2>

                <p className='text-gray-600 font-semibold'>
                  a) Information You Provide:
                </p>
                <ul className='list-disc pl-6 text-gray-600'>
                  <li>Chat messages or content shared with MagBot.</li>
                  <li>
                    Name, email, or phone number if registering or creating an
                    account.
                  </li>
                </ul>

                <p className='text-gray-600 font-semibold'>
                  b) Automatically Collected Information:
                </p>
                <ul className='list-disc pl-6 text-gray-600'>
                  <li>Device info (e.g., Windows 10, Chrome v120).</li>
                  <li>IP address (e.g., 203.0.113.25).</li>
                  <li>Usage logs and timestamps.</li>
                  <li>Cookies or tracking technologies.</li>
                </ul>

                <p className='text-gray-600 font-semibold'>
                  c) Optional / Additional Data:
                </p>
                <ul className='list-disc pl-6 text-gray-600'>
                  <li>Approximate location (city-level).</li>
                  <li>File uploads such as screenshots or documents.</li>
                </ul>
              </section>

              {/* 5. How We Use Data */}
              <section>
                <h2 className='text-xl font-semibold text-gray-700 mb-[10px]'>
                  5. How We Use Your Data
                </h2>
                <ul className='list-disc pl-6 text-gray-600'>
                  <li>To operate the chatbot and respond to user queries.</li>
                  <li>To improve product performance and add new features.</li>
                  <li>To personalize user interactions.</li>
                  <li>To enforce security and prevent fraud.</li>
                  <li>To send important service updates or notifications.</li>
                </ul>
              </section>

              {/* 6. Legal Basis */}
              <section>
                <h2 className='text-xl font-semibold text-gray-700 mb-[10px]'>
                  6. Legal Basis / Consent
                </h2>
                <p className='text-gray-600'>
                  Where required, we obtain explicit consent before processing
                  your data. You may withdraw consent anytime by emailing
                  support@magbot.ai. We may also process data based on
                  contractual or legal requirements.
                </p>
              </section>

              {/* 7. Data Retention */}
              <section>
                <h2 className='text-xl font-semibold text-gray-700 mb-[10px]'>
                  7. Data Retention
                </h2>
                <p className='text-gray-600'>
                  Your data is retained by Magbot for as long as your account or
                  the relevant data exists within the product. Upon deletion by
                  the user, all associated data is permanently removed and not
                  retained.
                </p>
              </section>

              {/* 8. Data Sharing */}
              <section>
                <h2 className='text-xl font-semibold text-gray-700 mb-[10px]'>
                  8. Data Sharing & Third Parties
                </h2>
                <ul className='list-disc pl-6 text-gray-600'>
                  <li>We do not sell your data.</li>
                  <li>
                    We may use trusted third-party service providers (AWS).
                  </li>
                  <li>We may comply with legal or regulatory requests.</li>
                  <li>
                    International data transfers include safeguards like SCCs.
                  </li>
                </ul>
              </section>

              {/* 9. Security */}
              <section>
                <h2 className='text-xl font-semibold text-gray-700 mb-[10px]'>
                  9. Security and Protection
                </h2>
                <ul className='list-disc pl-6 text-gray-600'>
                  <li>Encryption via HTTPS/TLS.</li>
                  <li>Role-based access controls.</li>
                  <li>Regular security audits and vulnerability checks.</li>
                </ul>
              </section>

              {/* 10. Cookies */}
              <section>
                <h2 className='text-xl font-semibold text-gray-700 mb-[10px]'>
                  10. Cookies / Tracking Technologies
                </h2>
                <p className='text-gray-600'>
                  We may use cookies for functionality, analytics, and
                  performance. Users can disable non-essential cookies in their
                  browser.
                </p>
              </section>

              {/* 11. Your Rights */}
              <section>
                <h2 className='text-xl font-semibold text-gray-700 mb-[10px]'>
                  11. Your Rights
                </h2>
                <ul className='list-disc pl-6 text-gray-600'>
                  <li>Request access to your data.</li>
                  <li>Correct or update personal information.</li>
                  <li>Request deletion (“Right to be Forgotten”).</li>
                  <li>Restrict or object to certain processing.</li>
                  <li>Withdraw previously given consent.</li>
                </ul>
              </section>

              {/* 12. Changes */}
              <section>
                <h2 className='text-xl font-semibold text-gray-700 mb-[10px]'>
                  12. Changes to This Privacy Policy
                </h2>
                <p className='text-gray-600'>
                  We may update this policy periodically. Significant changes
                  will be communicated via email or notifications within the
                  app.
                </p>
              </section>

              {/* 13. Contact */}
              <section>
                <h2 className='text-xl font-semibold text-gray-700 mb-[10px]'>
                  13. Contact / Complaints
                </h2>
                <ul className='list-disc pl-6 text-gray-600'>
                  <li>Email: support@magbot.ai</li>
                  <li>
                    Address: 5, 2nd Floor, Sri Radha Towers, 5, Raja Rajeshwari
                    Nagar, Namachivaya Nagar, Saravanampatti, Coimbatore, Tamil
                    Nadu 641035
                  </li>
                  <li>
                    You may also file a complaint with your local Data
                    Protection Authority.
                  </li>
                </ul>
              </section>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}

export default Privacy
